//@flow
import React from 'react';
import QuoteActions from '../../Actions/quote';
import IconClose from '../../Icon/components/IconClose.react';
import QuoteItem from './QuoteItem.react';
import GiftCardItem from './GiftCardItem.react';

import type ProductsCollection from '../../Stores/Products/productsCollection';
import type QuoteItemModel from '../../Stores/Quote/quoteItemModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  inCart:boolean,
  products:ProductsCollection,
  quoteItem:QuoteItemModel,
  quote:QuoteModel,
  lessTextMsrp:boolean,
  strikeUnselectedPrice?:boolean,
  stock?:StockCollection,
  membershipPlan:MembershipPlanModel,
};

export default class CartItem extends React.Component<Props> {

  removeProduct = () => {
    QuoteActions.deleteQuoteItem(this.props.quoteItem);
  }

  renderItem() {
    const sku = this.props.quoteItem.getSku();

    if (this.props.quoteItem.isGiftVoucher()) {
      const product = this.props.products.getProductBySku(sku);
      return (
        <GiftCardItem
          giftItem={this.props.quoteItem}
          removeProduct={this.removeProduct}
          product={product}
          type="quote"
        />
      );
    }

    return (
      <QuoteItem
        className="quote-item-block"
        inCart={this.props.inCart}
        quoteItem={this.props.quoteItem}
        products={this.props.products}
        quote={this.props.quote}
        lessTextMsrp={this.props.lessTextMsrp}
        strikeUnselectedPrice={this.props.strikeUnselectedPrice}
        preSale={this.props.stock && this.props.stock.preSale(sku)}
        membershipPlan={this.props.membershipPlan}
      />
    );
  }

  render() {
    return (
      <div className="cart-item">
        {this.renderItem()}
        <IconClose closeAction={this.removeProduct} className="cancel-item" />
      </div>
    );
  }
}
